import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";
import { checkAndInitGA, enableGA, initGA, disableGA } from "@/lib/analytics";

export const CookieConsent = () => {
  const { t, getLocalizedPath } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    checkAndInitGA();
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    enableGA();
    initGA();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem("cookie-consent", "declined");
    disableGA();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 animate-slide-up">
      <div className="mx-auto max-w-3xl glass rounded-2xl border border-border p-5 md:p-6 shadow-elevated">
        <div className="flex items-start gap-4">
          <div className="hidden md:flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
            <Cookie className="h-5 w-5 text-primary" />
          </div>
          <div className="flex-1 space-y-3">
            <p className="text-sm text-foreground/80 font-body leading-relaxed">
              {t.cookies.bannerText}{" "}
              <Link
                to={getLocalizedPath("/cookies-policy")}
                className="text-primary underline underline-offset-2 hover:text-primary/80 transition-colors"
              >
                {t.cookies.learnMore}
              </Link>
            </p>
            <div className="flex flex-col sm:flex-row gap-2">
              <Button onClick={accept} variant="gold" size="sm" className="text-xs">
                {t.cookies.acceptAll}
              </Button>
              <Button onClick={decline} variant="outline" size="sm" className="text-xs">
                {t.cookies.declineOptional}
              </Button>
            </div>
          </div>
          <button
            onClick={decline}
            className="shrink-0 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Close"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
